module.exports = __webpack_public_path__ + "img/gift.f82e5ab6.png";